module.exports = __webpack_public_path__ + "assets/media/phone-city.a1e63a5e.jpg";